import { z } from 'zod';

/** Stable, machine-readable API error codes. Clients branch on these, never on `message`. */
export const errorCodeSchema = z.enum([
  'UNAUTHENTICATED',
  'FORBIDDEN',
  'CSRF_REJECTED',
  'VALIDATION_FAILED',
  'NOT_FOUND',
  'CONFLICT',
  'DUPLICATE_REQUEST',
  'DECISION_STALE',
  'IDEMPOTENCY_KEY_REUSED',
  'PAYLOAD_TOO_LARGE',
  'UPSTREAM_UNAVAILABLE',
  'UPSTREAM_TIMEOUT',
  'INTERNAL',
]);

export type ErrorCode = z.infer<typeof errorCodeSchema>;

/** Body of every non-2xx API response. */
export const errorResponseSchema = z.object({
  code: errorCodeSchema,
  message: z.string(),
  details: z.unknown().optional(),
  requestId: z.string().optional(),
});

export type ErrorResponse = z.infer<typeof errorResponseSchema>;

const STATUS_BY_CODE: Record<ErrorCode, number> = {
  UNAUTHENTICATED: 401,
  FORBIDDEN: 403,
  CSRF_REJECTED: 403,
  VALIDATION_FAILED: 422,
  NOT_FOUND: 404,
  CONFLICT: 409,
  DUPLICATE_REQUEST: 409,
  DECISION_STALE: 409,
  IDEMPOTENCY_KEY_REUSED: 422,
  PAYLOAD_TOO_LARGE: 413,
  UPSTREAM_UNAVAILABLE: 503,
  UPSTREAM_TIMEOUT: 504,
  INTERNAL: 500,
};

/** HTTP status the API responds with for a given error code. */
export function httpStatusForErrorCode(code: ErrorCode): number {
  return STATUS_BY_CODE[code];
}
